import { useDispatch, useSelector } from 'react-redux';
import { activeTasksPageSelector } from '../../selectors/admin.selectors';
import { setActiveTasksPage } from '../../actions/admin.actions';
import { useAnnotationTaskData } from '../../hooks/useAnnotationTaskData';
import { AnnotationTaskTable } from './AnnotationTaskTable';

export const AnnotationTaskActive = () => {
  const dispatch = useDispatch();
  const activeTasksPage = useSelector(activeTasksPageSelector);
  const instanceActive = useAnnotationTaskData('ongoing', activeTasksPage);
  const incrementActivePage = () =>
    dispatch(setActiveTasksPage({ page: activeTasksPage + 1 }));

  return (
    <>
      <AnnotationTaskTable
        instance={instanceActive}
        incrementPage={incrementActivePage}
      />
    </>
  );
};
